import styles from "./TabBar.module.css";

export const TabId = {
    SLOT: 'slot',
    CASINO: 'casino',
    CASINO_LIVE: 'casinoLive',
    FAVORITES: 'favorites'
} as const;

export type TabId = typeof TabId[keyof typeof TabId];

export interface Tab {
    id: TabId;
    label: string;
    icon: string;
    gameType?: string;
}

interface TabBarProps {
    selectedTab: TabId;
    onTabSelect: (tab: Tab) => void;
}

export const tabs: Tab[] = [
    {
        id: TabId.SLOT,
        label: 'Slots',
        icon: '/tab/tab-slot.svg',
        gameType: 'slot'
    },
    {
        id: TabId.CASINO,
        label: 'Casino',
        icon: '/tab/tab-casino.svg',
        gameType: 'casino'
    },
    {
        id: TabId.CASINO_LIVE,
        label: 'Casino Live',
        icon: '/tab/tab-casinolive.svg',
        gameType: 'casinoLive'
    }/*,
    {
        id: TabId.FAVORITES,
        label: 'Preferiti',
        icon: '/tab/tab-fav.svg'
    }
    */
];

const TabBar = ({ selectedTab, onTabSelect }: TabBarProps) => {
    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-2xl border-t border-white/10">
            <div className="safe-area-inset-bottom">
                <div className="flex justify-around items-center h-12 px-2">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            onClick={() => onTabSelect(tab)}
                            className="flex flex-col items-center justify-center min-w-0 flex-1 h-full py-1 px-2 transition-all duration-200"
                        >
                            <div className={`relative flex items-center justify-center ${selectedTab === tab.id ? styles.tabSelected : ''}`}>
                                <img
                                    src={tab.icon}
                                    alt={tab.label}
                                    className={`w-6 h-6 object-contain ${
                                        selectedTab === tab.id ? 'opacity-100' : 'opacity-70'
                                    }`}
                                />
                            </div>
                            <span className={`text-[10px] mt-0.5 leading-tight ${
                                selectedTab === tab.id
                                    ? `font-medium ${styles.tabSelected}`
                                    : 'text-gray-400 font-normal'
                            }`}>
                                {tab.label}
                            </span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TabBar;